<template>
  <div class="index">
    <div class="page-booking">
      <div class="search-box">
        <div class="search">
          <input type="text" class="ipt" :placeholder="`热门搜索：龙角散 博多${hotSearch}`" v-model="searchText" @keyup.enter="toSearch" />
          <div class="btn-search" @click="toSearch">
            <img class="icon" src="../assets/icons/icon_search.png" alt="">
          </div>
        </div>
      </div>
      <swiper class="menu-list" :options="swiperOption">
        <swiper-slide
          :class="['menu-item', {active: item.value === menuActive}]"
          v-for="item in menu"
          :key="item.value">
          <div @click="menuClick(item.value)">
            <img class="icon" :src="require(`../assets/icons/index_menu${item.icon}${item.value === menuActive ? '_cur' : ''}.png`)" alt="">
            <p class="name">{{item.name}}</p>
          </div>
        </swiper-slide>
      </swiper>
      <div class="tip" v-if="bookingRemind">
        <img class="icon" src="../assets/icons/icon_horn.png" alt="">
        <p class="text el">{{bookingRemind}}</p>
        <div class="btn-close" @click="$store.commit('store', { bindTicket: { bookingRemind: '' } })">
          <van-icon class="icon-close" name="cross" />
        </div>
      </div>
      <!-- banner -->
      <index-banner :list="bannerList" />
      <normal-list ref="normalList" type="type" :query="query" />
    </div>
    <!-- footer -->
    <base-footer />
    <!-- 提醒弹框 -->
    <van-dialog v-model="popupMessageShow" title="">
      <div class="popup-message" v-html="popupMessage"></div>
    </van-dialog>
  </div>
</template>

<script>
import { serviceMenu } from '@/utils/dict'
import { orderBy } from 'lodash'
import IndexBanner from './index/IndexBanner'
import BaseFooter from '@/components/BaseFooter'
import api from '@/api'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import { mapState, mapGetters } from 'vuex'
import BookingNormalList from './booking/BookingNormalList'

export default {
  name: 'Index',
  components: {
    IndexBanner,
    'normal-list': BookingNormalList,
    BaseFooter
  },

  data () {
    return {
      swiperOption: {
        freeMode: true,
        slidesPerView: 'auto',
        resistanceRatio: 0
      },
      menuActive: 'hjsc',
      adSwiperOption: {
        autoplay: true,
        pagination: {
          el: '.swiper-pagination'
        }
      },
      bannerList: [],
      customViewModels: [],
      playStrategories: [],
      popupMessageShow: false,
      popupMessage: '',
      searchText: '',
      hotSearch: '',
      miniappShow: false,
      query: ''
    }
  },

  watch: {
    async miniappShow (flag) {
      if (!flag) {
        showLoading()
        await this.getPopupMessage()
        hideLoading()
      }
    }
  },

  computed: {
    ...mapState(['token']),
    ...mapGetters(['bookingRemind']),
    menu () {
      return orderBy(serviceMenu.filter(x => x.bookingIndex !== ''), ['bookingIndex'])
    }
  },
  async mounted () {
    const { isFromMiniApp, orderId, bookingId, shipCode, sailDate } = this.$route.query
    showLoading()
    await this.getData()
    if (this.token && isFromMiniApp === 'true' && (orderId || (bookingId && shipCode && sailDate))) {
      this.miniappShow = true
    } else {
      // await this.getPopupMessage()
      hideLoading()
    }
    // const { data } = await api.getHotSearch()
    // if (data.length) this.hotSearch = data.join(' ')
    await this.$nextTick()
    window.scrollTo(0, 0)
  },

  methods: {
    async getPopupMessage () {
      if (this.$store.state.indexPopupMessageLoaded) return
      const { data } = await api.getPopupMessage()
      if (data.rows.length) {
        this.popupMessageShow = true
        this.popupMessage = data.rows[0].content
        this.$store.commit('store', { indexPopupMessageLoaded: true })
      }
    },
    async getData () {
      const { errCode, errMsg, data } = await api.getBanner()
      if (errCode === 0) {
        const { PictureModels } = data
        this.bannerList = PictureModels
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
    },
    // bindGio () {
    //   try {
    //     window.gio('page.set', 'Product_Category', this.type)
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    async toSearch () {
      // if (!this.searchText.trim()) return
      this.$router.push(`/search?q=${this.searchText}`)
      // window.console.log(this.searchText)
      this.query = this.searchText
    },
    menuClick (value) {
      if (value === this.menuActive) return
      // this.$router.replace(`/Rccl.PCP/product/${value}`)
      window.location.href = process.env.VUE_APP_MB + `/Rccl.PCP/product/${value}`
    },
    handleMobileBannerClick (url) {
      if (url === null) return
      location.href = url
    }
  }
}
</script>

<style lang="less" scoped>
.index-menu {
  margin-bottom: 32px;
  border-radius: 8px;
  overflow: hidden;
  ::v-deep .van-grid-item__icon {
    font-size: 1.22rem;
  }
  ::v-deep .van-grid-item__text {
    font-size: .26rem;
  }
  ::v-deep [class*=van-hairline]::after {
    border-color: #f3f3f3;
  }
}
.menu-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 144px;
  box-sizing: border-box;
  border-bottom: 3px solid #fff;
  background-color: #fff;
  &.active {
    border-color: #1174b8;
    .name {
      color: @main-gray2;
    }
  }
  .icon {
    display: block;
    height: 42px;
    margin: 0 auto;
  }
  .name {
    margin-top: 14px;
    font-size: 28px;
    color: @main-gray4;
  }
}
.ad-swiper {
  height: 200px;
  margin-bottom: 40px;
  .img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
}
.index ::v-deep .btn-small {
  display: block;
  width: 150px;
  height: 48px;
  margin-top: 18px;
  border-radius: 6px;
  font-size: 24px;
  text-align: center;
  color: #333;
  line-height: 48px;
  background: url("../assets/btn_bg.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
.popup-message {
  padding: 24px;
}
.search-box {
  padding: 25px 36px 28px;
  .search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 72px;
    padding: 0 0 0 46px;
    border-radius: 36px;
    font-size: 24px;
    color: @main-gray4;
    background-color: #fff;
    .ipt {
      flex: 1;
      height: 34px;
      margin-top: 3px;
      padding-right: 24px;
      font-size: 24px;
      color: #333;
      line-height: 34px;
      border: none;
      outline: none;
    }
    .btn-search {
      flex: none;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 72px;
      height: 72px;
      padding-right: 20px;
      .icon {
        flex: none;
        width: 29px;
      }
    }
  }
}
.tip {
  display: flex;
  align-items: center;
  height: 90px;
  padding: 0 20px 0 18px;
  font-size: 24px;
  color: @main-gray2;
  background-color: #fbc300;
  .icon {
    flex: none;
    width: 24px;
    margin-right: 8px;
  }
  .btn-close {
    flex: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 42px;
    height: 42px;
    margin-left: 30px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, .1);
    .icon-close {
      font-size: 22px;
    }
  }
}
</style>
